import { clsx, type ClassValue } from 'cn';
import { extendTailwindMerge } from 'cn/config';

/**
 * ENG-1446: the merge engine (the `cn` package, which replaced tailwind-merge
 * with the same config API) only knows Tailwind's built-in scales, so a custom
 * token registered in `@theme inline` is invisible to it and lands in no
 * conflict group. `cn('tracking-caps', 'tracking-wider')` kept BOTH classes and
 * let stylesheet order pick the winner — the exact bug `cn` exists to prevent,
 * and silent, because the markup still looks correct.
 *
 * Every custom key added to `@theme inline` in `src/index.css` must be mirrored
 * here under its Tailwind v4 theme namespace (`text`, `tracking`, `shadow`,
 * `radius`, `color`, …), or overrides of it stop working.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      // sub-`xs` type scale (ENG-1445)
      text: ['2xs', '3xs', '4xs', '5xs'],
      // small-caps letter-spacing (ENG-1445)
      tracking: ['caps', 'caps-wide'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
